import * as Yup from 'yup'

const yupTags = Yup.object().shape({
  formInput: Yup.object().shape({
    tagName: Yup.string().required('Plese Enter'),
  }),
})

export default yupTags
